import styled from 'styled-components';

import logos from '../../assets/images/sidebar.png';

interface ScHeaderWrapper {
	burgerIconColor: string;
}

export const ScHeaderWrapper = styled.div<ScHeaderWrapper>`
	padding: 20px 0;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	height: 65px;
	margin-bottom: -65px;
	box-sizing: border-box;
	z-index: 10000;
	position: relative;
	isolation: isolate;
	.burger-icon {
		path {
			stroke: ${({ burgerIconColor }) => burgerIconColor};
		}
	}
	svg:first-child {
		width: 111px;
		height: auto;
		cursor: pointer;
	}
	@media (min-width: 768px) {
		height: 95px;
		margin-bottom: -95px;
		svg:first-child {
			width: 250px;
		}
	}
	@media (min-width: 1220px) {
		height: 120px;
		margin-bottom: -120px;
		font: ${({ theme }) => theme.fonts.button.large};
		padding: 50px 0 16px 0;
	}
`;

export const ScHeaderNavigation = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 17px;
`;

export const ScHeaderNavigationList = styled.ul`
	display: grid;
	grid-template-columns: 35px 63px 79px 90px 35px;
	max-height: 58px;
	height: 58px;
	align-items: center;
	gap: 30px;
	padding: 0 42px;
	margin: 0;
	border-radius: 90px;
	background: ${({ theme }) => theme.colors.strongWhite};
	border: ${({ theme }) => `2px solid ${theme.colors.darkText}`};
	list-style-type: none;
	> li {
		font: ${({ theme }) => theme.fonts.header.link};
		cursor: pointer;
		transition: 0.2s liear;
		padding: 18px 0;
		height: 58px;
		box-sizing: border-box;
		line-height: 25px !important;
	}
	> li:hover {
		font-weight: 700;
		font-family: 'GeomanistMedium' !important;
		line-height: 20px !important;
	}
	.dropdown {
		font: ${({ theme }) => theme.fonts.header.dropdown};
		position: relative;
	}
`;

export const ScDropdowListWrapper = styled.li`
	display: flex;
	flex-direction: column;
	height: fit-content;
	> div {
		padding-top: 15px;
		position: absolute;
		top: 100%;
		right: -42px;
		z-index: 11002;
	}

	a {
		color: ${({ theme }) => theme.colors.black};
	}
`;

export const ScDropdowListContainer = styled.ul`
	width: fit-content;
	color: ${({ theme }) => theme.colors.darkText};
	margin: 0;
	background: ${({ theme }) => theme.colors.strongWhite};
	cursor: auto;
	border: ${({ theme }) => `2px solid ${theme.colors.darkText}`};
	display: flex;
	flex-direction: column;
	gap: 4px;
	list-style-type: none;
	padding: 18px 7px;
	border-radius: 15px;
	position: relative;
	z-index: 11003;
	a {
		text-decoration: none;
		cursor: pointer;
	}
	button {
		background: transparent;
		border: 0;
		padding: 0;
		margin: 0;
		text-align: left;
		width: 100%;
		cursor: pointer;
		font: inherit;
		color: inherit;
	}
	li {
		font: ${({ theme }) => theme.fonts.header.link};
		color: ${({ theme }) => theme.colors.darkText};
		text-decoration: none;
		cursor: auto;
		margin: 0;
		min-width: max-content;
		width: auto;
	}
	span {
		width: max-content;
		padding: 10px 17px;
		display: block;
		transition: 0.2s linear;
		border-radius: 65px;
	}
	> li:hover {
		span {
			color: ${({ theme }) => theme.colors.white};
			background: ${({ theme }) => theme.colors.marmelade};
		}
	}
`;

interface IScSidebarWrapper {
	isOpen?: boolean;
}

export const ScSidebarWrapper = styled.div<IScSidebarWrapper>`
	background: ${({ theme }) => theme.colors.toasted};
	position: fixed;
	transition: 0.2s linear;
	right: ${({ isOpen }) => (isOpen ? 0 : '-120vw')};
	top: 0;
	width: 100vw;
	height: 100vh;
	overflow: auto;
	z-index: 10000;
	display: flex;
	flex-direction: column;
	gap: 35px;
	justify-content: space-between;
`;

export const ScMobileHeaderGroups = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
`;

export const ScSidebarContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 75px;
	margin-bottom: 20px;
`;

export const ScSidebarHeaderWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 20px;
	align-items: center;
	.close {
		transform: rotate(45deg);
		width: 22px;
		height: 22px;
	}
	svg:first-child {
		width: 111px;
		height: auto;
	}

	@media (min-width: 768px) {
		svg:first-child {
			width: 250px;
		}
	}
`;

export const ScSidebarLogos = styled.div`
	height: 180px;
	min-height: 180px;
	width: 100%;
	background-image: url(${logos});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	margin-bottom: 20px;
	@media (min-width: 768px) {
		height: 360px;
		min-height: 360px;
	}
`;
